export default __webpack_public_path__ + "static/media/suran.c1a469cf.png";